<!-- Adapted from YesPlayMusic v0.4.11 src/views/playlist.vue (MIT, Copyright (c) 2020-2023 qier222). Original page structure and SCSS retained; data/actions use the local and Cloudflare runtime. -->
<template>
  <div class="playlist" :class="{ 'salt-detail': salt }">
    <div v-if="loading" class="page-state" role="status">正在载入歌单…</div>
    <div v-else-if="error" class="page-state" role="alert"><p>{{ error }}</p><SaltButton v-if="salt" data-scroll-retry @click="loadData" style-type="subtle">重试</SaltButton><ButtonTwoTone v-else color="grey" data-scroll-retry @click.native="loadData">重试</ButtonTwoTone><router-link v-if="accountRoute" :to="'/library?tab=accounts&platform=' + accountRoute.platform">前往平台账号</router-link></div>
    <template v-else>
      <div class="playlist-info"><div v-if="editableCover" class="cover playlist-cover-editor" :style="{width:(salt ? 160 : 288)+'px'}"><SaltButton v-if="salt" class="playlist-cover-button" style-type="plain" aria-label="更换歌单封面" :disabled="coverBusy" @click="$refs.coverInput.click()"><PlaylistArtwork :playlist-id="ownedPlaylist.id" :alt="item.name" /><span>{{ coverBusy ? '正在保存…' : '更换封面' }}</span></SaltButton><button v-else class="playlist-cover-button" type="button" aria-label="更换歌单封面" :disabled="coverBusy" @click="$refs.coverInput.click()"><PlaylistArtwork :playlist-id="ownedPlaylist.id" :alt="item.name" /><span>{{ coverBusy ? '正在保存…' : '更换封面' }}</span></button><input ref="coverInput" data-playlist-cover-input type="file" accept="image/jpeg,image/png,image/webp" hidden @change="changeCover" /></div><PlaylistArtwork v-else-if="ownedPlaylist" class="cover playlist-cover-image" :playlist-id="ownedPlaylist.id" :alt="item.name" :style="{width:(salt ? 160 : 288)+'px'}" /><Cover v-else :key="routeId" :id="item.id" :image-url="coverUrl" :image-retry-key="coverRetryKey" @source-error="repairCover(accountRoute, $event)" :show-play-button="false" :always-show-shadow="!salt" :always-show-play-button="!salt" :fixed-size="salt ? 160 : 288" type="playlist" :cover-hover="false" /><div class="info"><div class="title">{{ item.name }}</div><div class="artist">{{ isLocal ? '我的音乐库' : '歌单' }}<span v-if="item.creator && item.creator.nickname"> · {{ item.creator.nickname }}</span></div><div class="date-and-count">{{ countLabel }} · {{ nextCursor ? '已加载时长 ' : '' }}{{ duration }}</div><div v-if="item.description" class="description" :class="{ expanded: fullDescription }" tabindex="0" @click="fullDescription = !fullDescription" @keydown.enter="fullDescription = !fullDescription">{{ item.description }}</div><p v-if="coverError" class="cover-error" role="alert">{{ coverError }}</p><div class="buttons detail-actions"><SaltButton v-if="salt && editableCover && ownedPlaylist.customCover" :disabled="coverBusy" style-type="subtle" @click="resetCover" class="detail-secondary" aria-label="恢复自动封面" title="恢复自动封面"><svg-icon class="detail-action-icon" icon-class="repeat" aria-hidden="true" /><span class="detail-action-label">恢复自动封面</span></SaltButton><ButtonTwoTone v-else-if="editableCover && ownedPlaylist.customCover" color="grey" :disabled="coverBusy" @click.native="resetCover" class="detail-secondary" aria-label="恢复自动封面" title="恢复自动封面"><svg-icon class="detail-action-icon" icon-class="repeat" aria-hidden="true" /><span class="detail-action-label">恢复自动封面</span></ButtonTwoTone><SaltButton v-if="salt" :disabled="!tracks.length || !!completeAction" @click="playAll"><template #leading><svg-icon icon-class="play" /></template>播放</SaltButton><ButtonTwoTone v-else icon-class="play" :disabled="!tracks.length || !!completeAction" @click.native="playAll">播放</ButtonTwoTone><SaltButton v-if="salt" :disabled="!tracks.length || !!completeAction" @click="enqueueAll" style-type="subtle" class="detail-secondary" aria-label="加入队列" title="加入队列"><svg-icon class="detail-action-icon" icon-class="list" aria-hidden="true" /><span class="detail-action-label">加入队列</span></SaltButton><ButtonTwoTone v-else color="grey" :disabled="!tracks.length || !!completeAction" @click.native="enqueueAll" class="detail-secondary" aria-label="加入队列" title="加入队列"><svg-icon class="detail-action-icon" icon-class="list" aria-hidden="true" /><span class="detail-action-label">加入队列</span></ButtonTwoTone><SaltButton v-if="salt" :disabled="!tracks.length || !!completeAction" @click="downloadAll" style-type="subtle" class="detail-secondary" aria-label="批量下载" title="批量下载"><svg class="detail-action-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3v12m-5-5 5 5 5-5M5 16v4h14v-4" /></svg><span class="detail-action-label">批量下载</span></SaltButton><ButtonTwoTone v-else color="grey" :disabled="!tracks.length || !!completeAction" @click.native="downloadAll" class="detail-secondary" aria-label="批量下载" title="批量下载"><svg class="detail-action-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3v12m-5-5 5 5 5-5M5 16v4h14v-4" /></svg><span class="detail-action-label">批量下载</span></ButtonTwoTone><SaltButton v-if="salt && (ownedPlaylist)" @click="deletePlaylist" style-type="subtle" destructive class="detail-secondary" aria-label="删除歌单" title="删除歌单"><svg-icon class="detail-action-icon" icon-class="x" aria-hidden="true" /><span class="detail-action-label">删除歌单</span></SaltButton><ButtonTwoTone v-else-if="ownedPlaylist" color="grey" @click.native="deletePlaylist" class="detail-secondary" aria-label="删除歌单" title="删除歌单"><svg-icon class="detail-action-icon" icon-class="x" aria-hidden="true" /><span class="detail-action-label">删除歌单</span></ButtonTwoTone><SaltButton v-if="salt && (!isLocal)" :disabled="!tracks.length || !!completeAction" @click="savePlaylist" style-type="subtle" class="detail-secondary" aria-label="保存到音乐库" title="保存到音乐库"><svg-icon class="detail-action-icon" icon-class="plus" aria-hidden="true" /><span class="detail-action-label">保存到音乐库</span></SaltButton><ButtonTwoTone v-else-if="!isLocal" color="grey" :disabled="!tracks.length || !!completeAction" @click.native="savePlaylist" class="detail-secondary" aria-label="保存到音乐库" title="保存到音乐库"><svg-icon class="detail-action-icon" icon-class="plus" aria-hidden="true" /><span class="detail-action-label">保存到音乐库</span></ButtonTwoTone></div></div></div>
      <component :is="salt ? 'SaltCard' : 'div'" v-if="ownedPlaylist" class="folder-import"><SaltButton v-if="salt" style-type="subtle" :disabled="state.importTask && state.importTask.status === 'running'" @click="$refs.importFolder.click()">导入文件夹到歌单</SaltButton><button v-else class="plain-button" type="button" :disabled="state.importTask && state.importTask.status === 'running'" @click="$refs.importFolder.click()">导入文件夹到歌单</button><SaltItem v-if="salt" title="保存音频到浏览器" description="不保存时刷新后需重新选择原文件。" clickable role="switch" :aria-checked="String(persistent)" @click="persistent = !persistent"><template #trailing><SaltSwitch :value="persistent" :interactive="false" /></template></SaltItem><label v-else><input v-model="persistent" type="checkbox" @keydown.enter.stop.prevent="activatePersistentSwitch" /> 保存音频到浏览器</label><span v-if="!salt">不保存时刷新后需重新选择原文件。</span><input ref="importFolder" data-playlist-folder-input type="file" webkitdirectory multiple hidden @change="importFolder" /></component>
      <ImportReport v-if="ownedPlaylist && state.importTask && state.importTask.playlistId === ownedPlaylist.id" />
      <HistoryRange v-if="routeId === 'history'" v-model="historyRange" :salt="salt" :untimed-count="untimedHistoryCount" @tick="historyNow = $event" />
      <TrackList v-if="tracks.length" :id="item.id" :tracks="tracks" :load-playback-tracks="collectTracks" type="playlist" :extra-context-menu-item="ownedPlaylist ? ['removeTrackFromPlaylist'] : []" @remove-track="removeFromPlaylist" />
      <div v-else class="page-state"><p>{{ routeId === 'history' ? historyRange === 'week' ? '最近一周还没有播放记录。' : '播放过的音乐会出现在这里。' : isLocal ? '歌单中还没有音乐。' : '当前已读取部分没有可匿名播放的歌曲。' }}</p><router-link v-if="isLocal && routeId !== 'history'" to="/library">前往音乐库添加歌曲</router-link></div>
      <p v-if="completeAction" class="page-state" role="status">正在读取完整歌单，已加载 {{ remoteTracks.length }}{{ remoteTotal === null ? '' : ' / ' + remoteTotal }} 首…</p>
      <p v-if="partial" class="page-state">上游未返回部分曲目；播放会使用所选音源解析同一歌曲。</p>
      <p v-if="moreError" class="error-state" role="status">{{ moreError }} <SaltButton v-if="salt" style-type="plain" data-scroll-retry @click="retryMore">重试</SaltButton><button v-else data-scroll-retry @click="retryMore">重试</button></p>
      <div v-if="nextCursor !== null" ref="prefetch" class="load-more" role="status">{{ loadingMore ? '正在载入更多歌曲…' : moreError ? '' : '继续滚动自动载入' }}</div>
    </template>
  </div>
</template>
<script>
import { runtime } from '../bridge';
import { observeListPrefetch } from '../list-prefetch';
import { historyTrackIds } from '../play-history';
import HistoryRange from '../components/HistoryRange.vue';
import {workspace,workspaceAllowsTrack} from '../workspace';
import { openDownloads } from '../downloads';
import { matchesLibrarySource, normalizeLibrarySource } from '../library-source';
import { accountStates, parseAccountPlaylistRoute, readAccountPlaylist, importAccountPlaylist, repairAccountPlaylistCover } from '../accounts';
import { reconcileAccountPlaylistCover } from '../account-library-cache';
import ButtonTwoTone from '../components/ButtonTwoTone.vue';
import SaltButton from '../salt/ui/SaltButton.vue';
import SaltCard from '../salt/ui/SaltCard.vue';
import SaltItem from '../salt/ui/SaltItem.vue';
import SaltSwitch from '../salt/ui/SaltSwitch.vue';
import TrackList from '../components/TrackList.vue';
import Cover from '../components/Cover.vue';
import ImportReport from '../components/ImportReport.vue';
import PlaylistArtwork from '../components/PlaylistArtwork.vue';
import { cropPlaylistCover } from '../../playlist-cover';
import { generatedPlaylistArtwork } from '../playlist-artwork';
// Keep the view's lightweight VM fixtures usable when they omit visual-only
// Salt controls; the normal app always resolves the imported components.
export default {
  name: 'Playlist', components: { ButtonTwoTone, SaltButton, SaltCard, SaltItem, SaltSwitch, TrackList, Cover, ImportReport, HistoryRange, PlaylistArtwork },
  data() { return { workspace, state: runtime.state, historyRange: 'all', historyNow: Date.now(), persistent: true, loading: false, error: '', remoteItem: {}, remoteTracks: [], fullDescription: false, requestId: 0, nextCursor: null, partial: false, loadingMore: false, moreError: '', requestAbort: null, remoteTotal: null, remoteUnavailable: 0, completeAction: '', coverBusy: false, coverError: '', coverRequestId: 0 }; },
  computed: {
    salt() { return this.workspace.appearance === 'salt'; },
    scrollRestoreState() { return { busy: this.loading || this.loadingMore, more: !this.isLocal && this.nextCursor !== null, failed: Boolean(this.error || this.moreError) }; },
    routeId() { return String(this.$route.params.id || ''); },
    sourceFilter() { return normalizeLibrarySource(this.$route.query.source); },
    accountRoute() { return parseAccountPlaylistRoute(this.routeId); },
    listedAccountCover() { const route = this.accountRoute; if (!route || accountStates[route.platform].profile?.id !== route.accountId) return null; const item = accountStates[route.platform].playlists.find(item => item.id === route.playlistId); return item ? { routeId: this.routeId, coverUrl: item.coverUrl || '', coverUpdatedAt: item.coverUpdatedAt || '' } : null; },
    ownedPlaylist() { return this.state.playlists.find(p => String(p.id) === this.routeId); },
    editableCover() { return Boolean(this.ownedPlaylist && !this.ownedPlaylist.id.startsWith('account:') && !this.ownedPlaylist.origin); },
    isLocal() { return !!this.ownedPlaylist || ['favorites', 'history', 'recent', 'local:all'].includes(this.routeId); },
    item() { if (this.ownedPlaylist) return this.ownedPlaylist; if (this.isLocal) return { id: this.routeId, name: { favorites: '我喜欢的音乐', history: '最近播放', recent: '最近添加', 'local:all': '全部歌曲' }[this.routeId], description: this.routeId === 'favorites' ? '你在此浏览器中收藏的歌曲。' : '' }; return this.remoteItem; },
    historyTracks() { return this.state.history.map(id => this.state.tracks.find(track => track.id === id)).filter(track => track && matchesLibrarySource(track, this.sourceFilter) && (!this.salt || workspaceAllowsTrack(track))); },
    untimedHistoryCount() { return this.historyTracks.filter(track => !this.state.historyPlayedAt[track.id]).length; },
    tracks() { if (!this.isLocal) return this.remoteTracks.filter(track => matchesLibrarySource(track, this.sourceFilter)); if (this.routeId === 'history') { const ids = new Set(historyTrackIds(this.state.history, this.state.historyPlayedAt, this.historyRange, this.historyNow)); return this.historyTracks.filter(track => ids.has(track.id)); } const ids = this.ownedPlaylist ? this.ownedPlaylist.trackIds : this.routeId === 'favorites' ? this.state.favorites : runtime.libraryTracks().map(t => t.id); return ids.map(id => this.state.tracks.find(t => t.id === id)).filter(track => track && matchesLibrarySource(track, this.sourceFilter)); },
    coverUrl() { return this.item.coverImgUrl || this.item.picUrl || (this.accountRoute ? generatedPlaylistArtwork(this.tracks, runtime.coverCandidate) : runtime.cover(this.tracks.find(track => track.artworkRef) || this.tracks[0])); },
    coverRetryKey() { const route = this.accountRoute; return route && this.listedAccountCover ? `${accountStates[route.platform].fetchedAt || ''}:${this.listedAccountCover.coverUpdatedAt || ''}` : this.remoteItem.coverUpdatedAt || ''; },
    countLabel() { return this.isLocal ? this.tracks.length + ' 首歌曲' : this.remoteTotal === null ? '已加载 ' + this.tracks.length + ' 首' : '共 ' + this.remoteTotal + ' 首歌曲' + (this.remoteTotal !== this.tracks.length ? ' · 已加载 ' + this.tracks.length + ' 首' : ''); },
    duration() { return runtime.formatTime(this.tracks.reduce((total, track) => total + (track.durationMs || 0), 0)); },
  },
  watch: { 'state.historyPlayedAt'() { this.historyNow = Date.now(); }, routeId: { immediate: true, handler() { this.loadData(); } }, listedAccountCover(value) { const route = this.accountRoute; if (!value || !route || value.routeId !== this.routeId || this.remoteItem.id !== this.routeId || accountStates[route.platform].profile?.id !== route.accountId) return; const cover = reconcileAccountPlaylistCover(this.remoteItem, { ...this.remoteItem, coverUrl: value.coverUrl, coverUpdatedAt: value.coverUpdatedAt }, '', value.coverUpdatedAt); this.remoteItem = { ...this.remoteItem, coverUrl: cover.coverUrl || '', coverImgUrl: cover.coverUrl || '', coverUpdatedAt: cover.coverUpdatedAt || '' }; } },
  mounted() { this.bindPrefetch(); },
  beforeDestroy() { this.requestId++; this.requestAbort?.abort(); this._disposePrefetch?.(); },
  methods: {
    activatePersistentSwitch(event) { if (!event.repeat) event.currentTarget.click(); },
    repairCover(identity, failure) { if (identity) void repairAccountPlaylistCover(identity.platform, identity.accountId, identity.playlistId, failure); },
    async changeCover(event) {
      const file = event.target.files?.[0]; event.target.value = '';
      if (!file || !this.editableCover) return;
      const id = this.ownedPlaylist.id, ticket = ++this.coverRequestId;
      this.coverBusy = true; this.coverError = '';
      try {
        const cover = await cropPlaylistCover(file);
        if (ticket !== this.coverRequestId || this.routeId !== id) return;
        await runtime.updatePlaylistCover(id, cover);
      } catch (error) { if (ticket === this.coverRequestId) this.coverError = error.message || '封面保存失败，原封面已保留'; }
      finally { if (ticket === this.coverRequestId) this.coverBusy = false; }
    },
    async resetCover() {
      if (!this.editableCover || this.coverBusy) return;
      this.coverBusy = true; this.coverError = '';
      try { await runtime.updatePlaylistCover(this.ownedPlaylist.id); }
      catch (error) { this.coverError = error.message || '恢复自动封面失败'; }
      finally { this.coverBusy = false; }
    },
    async importFolder(event) { const files = Array.from(event.target.files || []); event.target.value = ''; if (!files.length || !this.ownedPlaylist) return; try { await runtime.importFiles(files, this.persistent, this.ownedPlaylist.id); } catch (error) { runtime.notify(error.message || '文件夹导入失败', 'error'); } },
    async fetchPage(offset = 0) {
      if (!this.accountRoute) return runtime.catalog('playlist', this.routeId, { offset, limit: 100 });
      const route = this.accountRoute;
      const data = await readAccountPlaylist(route.platform, route.accountId, route.playlistId, Number(offset), this.requestAbort?.signal);
      const item = data.playlist;
      return { ...data, item: { ...item, id: this.routeId, coverImgUrl: item.coverUrl, creator: { nickname: item.creator }, description: '账号歌单 · 点击播放使用当前音源；保存到音乐库可保留本地副本。' }, tracks: (data.tracks || []).map(runtime.normalizeTrack), nextCursor: data.nextOffset === null || data.nextOffset === undefined ? null : String(data.nextOffset), partial: Boolean(data.unavailable), unavailableCount: data.unavailable || 0 };
    },
    bindPrefetch() {
      this._disposePrefetch?.();
      this.$nextTick(() => {
        this._disposePrefetch?.();
        if (!this.$refs.prefetch) return;
        this._disposePrefetch = observeListPrefetch(this.$refs.prefetch, () => {
          if (!this.moreError && !this.completeAction) void this.loadMore().catch(() => {});
        });
      });
    },
    applyPage(data, append = false) {
      const next = data.more && data.nextCursor !== null && data.nextCursor !== undefined ? String(data.nextCursor) : null;
      if (data.more && (next === null || !/^\d+$/.test(next) || !Number.isSafeInteger(Number(next)) || this._cursors.has(next) || Number(next) <= Number(append ? this.nextCursor : 0))) throw new Error('歌单分页没有前进，请重试');
      const tracks = append ? [...this.remoteTracks, ...(data.tracks || [])] : data.tracks || [];
      const unique = [...new Map(tracks.map(track => [track.id, track])).values()];
      const unavailable = Number.isSafeInteger(data.unavailableCount) && data.unavailableCount > 0 ? data.unavailableCount : 0;
      if (append && next !== null && unique.length === this.remoteTracks.length && ((data.tracks || []).length || !unavailable)) throw new Error('歌单分页没有前进，请重试');
      if (append && this.accountRoute && this.remoteItem.id === this.routeId && data.item?.id === this.routeId) {
        const cover = reconcileAccountPlaylistCover(this.remoteItem, data.item, '', data.fetchedAt);
        this.remoteItem = { ...this.remoteItem, coverUrl: cover.coverUrl || '', coverImgUrl: cover.coverUrl || '', coverUpdatedAt: cover.coverUpdatedAt || '' };
      }
      this.remoteTracks = unique;
      if (data.total != null && Number.isFinite(Number(data.total))) this.remoteTotal = Math.max(this.remoteTotal ?? 0, Number(data.total));
      this.remoteUnavailable = (append ? this.remoteUnavailable : 0) + unavailable;
      this.nextCursor = next;
      this.partial = this.partial || Boolean(data.partial);
    },
    async loadData() {
      const ticket = ++this.requestId;
      this.coverRequestId++; this.coverBusy = false; this.coverError = '';
      this.requestAbort?.abort(); this.requestAbort = new AbortController(); this._disposePrefetch?.();
      this._pagePromise = null; this._collectPromise = null; this._cursors = new Set(['0']);
      this.error = ''; this.fullDescription = false; this.nextCursor = null; this.partial = false;
      this.moreError = ''; this.loadingMore = false; this.completeAction = ''; this.remoteTotal = null; this.remoteUnavailable = 0;
      if (this.isLocal) { this.loading = false; return; }
      this.remoteTracks = []; this.remoteItem = {}; this.loading = true;
      try {
        const data = await this.fetchPage();
        if (ticket !== this.requestId) return;
        if (!data.item) throw new Error('没有找到这个歌单');
        this.remoteItem = data.item; this.applyPage(data);
      } catch (error) { if (ticket === this.requestId) this.error = error.message || '歌单载入失败'; }
      finally { if (ticket === this.requestId) { this.loading = false; this.bindPrefetch(); } }
    },
    retryMore() { return this.nextCursor === null ? this.loadData() : this.loadMore().catch(() => {}); },
    loadMore() {
      if (this._pagePromise) return this._pagePromise;
      if (this.nextCursor === null) return Promise.resolve();
      const ticket = this.requestId, cursor = this.nextCursor;
      this.loadingMore = true; this.moreError = '';
      const operation = (async () => {
        try {
          const data = await this.fetchPage(cursor);
          if (ticket !== this.requestId) throw new DOMException('歌单已切换', 'AbortError');
          this.applyPage(data, true); this._cursors.add(cursor);
        } catch (error) {
          if (ticket === this.requestId) this.moreError = error.message || '后续歌曲读取失败';
          throw error;
        } finally {
          if (ticket === this.requestId) { this.loadingMore = false; this._pagePromise = null; if (!this.moreError) this.bindPrefetch(); }
        }
      })();
      this._pagePromise = operation;
      return operation;
    },
    collectTracks() {
      if (this.isLocal) return Promise.resolve(this.tracks);
      if (this._collectPromise) return this._collectPromise;
      const ticket = this.requestId;
      const operation = (async () => {
        // Each request advances a verified cursor; a failure never starts a partial queue.
        while (this.nextCursor !== null) {
          await this.loadMore();
          if (ticket !== this.requestId) throw new DOMException('歌单已切换', 'AbortError');
        }
        if (this.remoteTotal !== null && this.remoteTracks.length + this.remoteUnavailable < this.remoteTotal) {
          this.moreError = '歌单尚未完整读取，请重试后再播放或保存全部'; throw new Error(this.moreError);
        }
        return this.tracks;
      })().finally(() => { if (ticket === this.requestId) this._collectPromise = null; });
      this._collectPromise = operation;
      return operation;
    },
    async runComplete(action, execute, current = () => true) {
      if (this.completeAction) return;
      const ticket = this.requestId; this.completeAction = action;
      try { const tracks = await this.collectTracks(); if (ticket === this.requestId && current()) await execute(tracks); }
      catch (error) { if (ticket === this.requestId && current() && error.name !== 'AbortError') runtime.notify('未执行' + action + '：' + (error.message || '歌单读取失败，请重试'), 'error'); }
      finally { if (ticket === this.requestId) { this.completeAction = ''; this.bindPrefetch(); } }
    },
    playAll() {
      if (this.completeAction) return;
      const playbackTicket = runtime.reservePlaybackRequest();
      return this.runComplete('播放全部', tracks => runtime.playTracks(tracks), () => runtime.isPlaybackRequestCurrent(playbackTicket));
    },
    enqueueAll() { return this.runComplete('加入队列', tracks => runtime.enqueueTracks(tracks)); },
    downloadAll() { return this.runComplete('批量下载', tracks => openDownloads(tracks, this.item.name || '歌单')); },
    removeFromPlaylist(id) { if (this.ownedPlaylist) runtime.removeFromPlaylist(id, this.ownedPlaylist.id); },
    async deletePlaylist() { if (!this.ownedPlaylist || !window.confirm('删除歌单「' + this.item.name + '」？歌曲仍保留在音乐库。')) return; await runtime.removePlaylist(this.item.id); this.$router.push('/library'); },
    savePlaylist() { return this.runComplete('保存歌单', async tracks => {
      if (this.accountRoute) { await importAccountPlaylist({ ...this.remoteItem, id: this.accountRoute.playlistId }, this.accountRoute.platform); return; }
      await runtime.createPlaylist(this.item.name, tracks);
      runtime.notify('已保存到音乐库');
    }); },
  },
};
</script>
<style lang="scss" scoped>
.folder-import { display:flex; flex-wrap:wrap; align-items:center; gap:12px 20px; margin:24px 0; color:var(--color-text); font-size:14px; }
.playlist-cover-editor { flex: none; }
.playlist-cover-button { display: block; position: relative; width: 100%; aspect-ratio: 1; padding: 0; border: 0; border-radius: 12px; overflow: hidden; background: transparent; cursor: pointer; }
.playlist-cover-button img, .playlist-cover-image { display: block; aspect-ratio: 1; height: auto; object-fit: cover; border-radius: inherit; }
.playlist-cover-button img { width: 100%; }
.playlist-cover-button span { position: absolute; inset: auto 0 0; padding: 8px; color: #fff; background: #0009; font-size: 12px; opacity: 0; }
.playlist-cover-button:hover span, .playlist-cover-button:focus-visible span, .playlist-cover-button:disabled span { opacity: 1; }
.playlist-cover-button:focus-visible { outline: none; box-shadow: inset 0 -2px var(--salt-accent,var(--color-primary)); }
.cover-error { color: var(--salt-error,#c42b1c); font-size: 12px; margin: 12px 0 0; }
.folder-import span { color:var(--color-secondary); }
.page-state { padding: 48px 0; color: var(--color-text); opacity: .78; line-height: 1.8; }
.page-state a { color: var(--color-primary); }
.playlist-info .info { min-width: 0; }
.playlist-info .info .description.expanded { -webkit-line-clamp: unset; white-space: pre-line; }
.playlist-info .buttons { flex-wrap: wrap; gap: 10px 0; }
button:disabled { opacity: .4; cursor: default; }
@media(max-width: 800px) { .playlist-info { width: 100%; flex-direction: column; margin-bottom: 36px; align-items: flex-start; } .playlist-info .info { margin: 24px 0 0; } .playlist-info .info .title { font-size: 32px; overflow-wrap: anywhere; } .playlist-info .info .artist { margin-top: 14px; } }

.playlist {
  margin-top: 32px;
}
.playlist-info {
  display: flex;
  margin-bottom: 72px;
  position: relative;
  .info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex: 1;
    margin-left: 56px;
    .title {
      font-size: 36px;
      font-weight: 700;
      color: var(--color-text);

      .lock-icon {
        opacity: 0.28;
        color: var(--color-text);
        margin-right: 8px;
        .svg-icon {
          height: 26px;
          width: 26px;
        }
      }
    }
    .artist {
      font-size: 18px;
      opacity: 0.88;
      color: var(--color-text);
      margin-top: 24px;
    }
    .date-and-count {
      font-size: 14px;
      opacity: 0.68;
      color: var(--color-text);
      margin-top: 2px;
    }
    .description {
      font-size: 14px;
      opacity: 0.68;
      color: var(--color-text);
      margin-top: 24px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      overflow: hidden;
      cursor: pointer;
      &:hover {
        transition: opacity 0.3s;
        opacity: 0.88;
      }
    }
    .buttons {
      margin-top: 32px;
      display: flex;
      button {
        margin-right: 16px;
      }
    }
  }
}

.special-playlist {
  margin-top: 192px;
  margin-bottom: 128px;
  border-radius: 1.25em;
  text-align: center;

  @keyframes letterSpacing4 {
    from {
      letter-spacing: 0px;
    }

    to {
      letter-spacing: 4px;
    }
  }

  @keyframes letterSpacing1 {
    from {
      letter-spacing: 0px;
    }

    to {
      letter-spacing: 1px;
    }
  }

  .title {
    font-size: 84px;
    line-height: 1.05;
    font-weight: 700;
    text-transform: uppercase;

    letter-spacing: 4px;
    animation-duration: 0.8s;
    animation-name: letterSpacing4;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    // background-image: linear-gradient(
    //   225deg,
    //   var(--color-primary),
    //   var(--color-primary)
    // );

    img {
      height: 78px;
      border-radius: 0.125em;
      margin-right: 24px;
    }
  }
  .subtitle {
    font-size: 18px;
    letter-spacing: 1px;
    margin: 28px 0 54px 0;
    animation-duration: 0.8s;
    animation-name: letterSpacing1;
    text-transform: uppercase;
    color: var(--color-text);
  }
  .buttons {
    margin-top: 32px;
    display: flex;
    justify-content: center;
    button {
      margin-right: 16px;
    }
  }
}

.gradient-test {
  background-image: linear-gradient(to left, #92fe9d 0%, #00c9ff 100%);
}

[data-theme='dark'] {
  .gradient-radar {
    background-image: linear-gradient(to left, #92fe9d 0%, #00c9ff 100%);
  }
}

.gradient-radar {
  background-image: linear-gradient(to left, #0ba360 0%, #3cba92 100%);
}

.gradient-blue-purple {
  background-image: linear-gradient(
    45deg,
    #89c4f5 0%,
    #6284ff 42%,
    #ff0000 100%
  );
}

.gradient-sharp-blue {
  background-image: linear-gradient(45deg, #00c6fb 0%, #005bea 100%);
}

.gradient-yellow-pink {
  background-image: linear-gradient(45deg, #f6d365 0%, #fda085 100%);
}

.gradient-pink {
  background-image: linear-gradient(45deg, #ee9ca7 0%, #ffdde1 100%);
}

.gradient-indigo-pink-yellow {
  background-image: linear-gradient(
    43deg,
    #4158d0 0%,
    #c850c0 46%,
    #ffcc70 100%
  );
}

.gradient-light-red-light-blue {
  background-image: linear-gradient(
    225deg,
    hsl(190, 30%, 50%) 0%,
    #081abb 38%,
    #ec3841 58%,
    hsl(13, 99%, 49%) 100%
  );
}

.gradient-fog {
  background: linear-gradient(-180deg, #bcc5ce 0%, #929ead 98%),
    radial-gradient(
      at top left,
      rgba(255, 255, 255, 0.3) 0%,
      rgba(0, 0, 0, 0.3) 100%
    );
  background-blend-mode: screen;
}

.gradient-red {
  background-image: linear-gradient(213deg, #ff0844 0%, #ffb199 100%);
}

.gradient-sky-blue {
  background-image: linear-gradient(147deg, #48c6ef 0%, #6f86d6 100%);
}

.gradient-dark-blue-midnight-blue {
  background-image: linear-gradient(213deg, #09203f 0%, #537895 100%);
}

.gradient-yellow-red {
  background: linear-gradient(147deg, #fec867 0%, #f72c61 100%);
}

.gradient-yellow {
  background: linear-gradient(147deg, #fceb02 0%, #fec401 100%);
}

.gradient-midnight-blue {
  background-image: linear-gradient(-20deg, #2b5876 0%, #4e4376 100%);
}

.gradient-orange-red {
  background-image: linear-gradient(147deg, #ffe53b 0%, #ff2525 74%);
}

.gradient-moonstone-blue {
  background-image: linear-gradient(
    147deg,
    hsl(200, 34%, 8%) 0%,
    hsl(204, 35%, 38%) 50%,
    hsl(200, 34%, 18%) 100%
  );
}

.gradient-pink-purple-blue {
  background-image: linear-gradient(
    to right,
    #ff3cac 0%,
    #784ba0 50%,
    #2b86c5 100%
  ) !important;
}

.gradient-green {
  background-image: linear-gradient(
    90deg,
    #c6f6d5,
    #68d391,
    #38b2ac
  ) !important;
}

.user-info {
  h1 {
    font-size: 42px;
    position: relative;
    color: var(--color-text);
    .avatar {
      height: 44px;
      margin-right: 12px;
      vertical-align: -7px;
      border-radius: 50%;
      border: rgba(0, 0, 0, 0.2);
    }
  }
}

.search-box {
  display: flex;
  position: absolute;
  right: 20px;
  bottom: -55px;
  justify-content: flex-end;
  -webkit-app-region: no-drag;

  .container {
    display: flex;
    align-items: center;
    height: 32px;
    background: var(--color-secondary-bg-for-transparent);
    border-radius: 8px;
    width: 200px;
  }

  .svg-icon {
    height: 15px;
    width: 15px;
    color: var(--color-text);
    opacity: 0.28;
    margin: {
      left: 8px;
      right: 4px;
    }
  }

  input {
    font-size: 16px;
    border: none;
    background: transparent;
    width: 96%;
    font-weight: 600;
    margin-top: -1px;
    color: var(--color-text);
  }

  .active {
    background: var(--color-primary-bg-for-transparent);
    input,
    .svg-icon {
      opacity: 1;
      color: var(--color-primary);
    }
  }
}

[data-theme='dark'] {
  .search-box {
    .active {
      input,
      .svg-icon {
        color: var(--color-text);
      }
    }
  }
}

.search-box-likepage {
  display: flex;
  position: absolute;
  right: 12vw;
  top: 95px;
  justify-content: flex-end;
  -webkit-app-region: no-drag;

  .input {
    transition: all 0.5s;
  }

  .container {
    display: flex;
    align-items: center;
    height: 32px;
    background: var(--color-secondary-bg-for-transparent);
    border-radius: 8px;
  }

  .svg-icon {
    height: 15px;
    width: 15px;
    color: var(--color-text);
    opacity: 0.28;
    margin: {
      left: 8px;
      right: 8px;
    }
  }

  input {
    font-size: 16px;
    border: none;
    background: transparent;
    width: 96%;
    font-weight: 600;
    margin-top: -1px;
    color: var(--color-text);
  }

  .active {
    background: var(--color-primary-bg-for-transparent);
    input,
    .svg-icon {
      opacity: 1;
      color: var(--color-primary);
    }
  }
}

[data-theme='dark'] {
  .search-box-likepage {
    .active {
      input,
      .svg-icon {
        color: var(--color-text);
      }
    }
  }
}

@media (max-width: 1336px) {
  .search-box-likepage {
    right: 8vw;
  }
}

.load-more {
  display: flex;
  justify-content: center;
  margin-top: 32px;
}

</style>

<style lang="scss" scoped>
/* SaltUI desktop typography, spacing and shared controls; YPM stays above. */
.playlist.salt-detail {
  margin-top:16px; color:var(--salt-text); font-size:var(--salt-text-main,14px);
  .playlist-info { width:100%; flex-direction:row; align-items:flex-start; gap:16px; margin-bottom:24px; }
  .playlist-info > .cover { flex:0 0 160px; width:160px; }
  .playlist-cover-button { border-radius: var(--salt-radius-medium,6px); }
  .playlist-cover-button ::v-deep .label { display:block; width:100%; height:100%; padding:0; overflow:visible; white-space:normal; }
  .playlist-cover-button ::v-deep .label > span:last-child { position:absolute; inset:auto 0 0; padding:8px; color:#fff; background:#0009; font-size:12px; opacity:0; }
  .playlist-cover-button:hover ::v-deep .label > span:last-child,.playlist-cover-button:focus-visible ::v-deep .label > span:last-child,.playlist-cover-button:disabled ::v-deep .label > span:last-child { opacity:1; }
  .playlist-info ::v-deep img { display:block; box-sizing:border-box; border-radius:var(--salt-radius-medium,6px); border-color:var(--salt-stroke); }
  .playlist-info .info { margin:0; min-width:0; }
  .playlist-info .info .title { font-size:var(--salt-text-title,24px); line-height:1.35; font-weight:500; overflow-wrap:anywhere; }
  .playlist-info .info .artist { margin-top:8px; color:var(--salt-subtext); font-size:14px; line-height:1.5; opacity:1; }
  .playlist-info .info .date-and-count { margin-top:2px; color:var(--salt-subtext); font-size:12px; line-height:1.5; opacity:1; }
  .playlist-info .info .description { margin-top:12px; color:var(--salt-subtext); font-size:14px; line-height:1.5; opacity:1; overflow-wrap:anywhere; }
  .playlist-info .info .buttons { margin-top:16px; gap:8px; }
  .playlist-info .info .buttons button { margin:0; }
  .salt-ui-button:disabled { opacity:1; }
  .folder-import { margin:16px 0; align-items:stretch; gap:0; }
  .folder-import ::v-deep .salt-ui-card { flex-direction:row; flex-wrap:wrap; align-items:center; gap:12px 16px; padding:12px 16px; }
  .folder-import label { display:inline-flex; align-items:center; gap:6px; font-size:14px; }
  .folder-import input[type='checkbox'] { accent-color:var(--salt-accent); }
  .folder-import span { color:var(--salt-subtext); font-size:12px; line-height:1.5; }
  .page-state { padding:24px 0; color:var(--salt-subtext); font-size:14px; opacity:1; }
  .error-state { color:var(--salt-subtext); font-size:14px; line-height:1.5; }
  .load-more { margin-top:16px; }
}

#app.salt-mobile-layout .playlist.salt-detail {
  --detail-mobile-cover-size:144px;
  margin-top:12px;
  .playlist-info { flex-direction:column; align-items:stretch; gap:16px; margin:0 0 20px; }
  .playlist-info > .cover { align-self:center; flex:0 0 auto; width:var(--detail-mobile-cover-size) !important; height:var(--detail-mobile-cover-size) !important; }
  .playlist-info > .cover ::v-deep .cover-container { width:100%; height:100%; }
  .playlist-info > .cover ::v-deep img { width:100% !important; height:100% !important; object-fit:cover; }
  .playlist-info .info { flex:none; width:100%; margin:0; }
  .playlist-info .info .title { font-size:24px; line-height:1.3; overflow-wrap:anywhere; }
  .playlist-info .info .artist,.playlist-info .info .date-and-count { overflow-wrap:anywhere; }
  .playlist-info .info .buttons { margin-top:12px; gap:8px; }
  .salt-ui-button { min-width:44px; min-height:44px; max-width:100%; }
  .buttons ::v-deep .label { white-space:normal; overflow-wrap:anywhere; }
  @media (orientation:landscape) and (max-height:599px) {
    --detail-mobile-cover-size:96px;
    .playlist-info { flex-direction:row; align-items:flex-start; gap:16px; margin-bottom:16px; }
    .playlist-info > .cover { align-self:flex-start; flex-basis:var(--detail-mobile-cover-size); }
    .playlist-info .info { flex:1; width:auto; }
    .playlist-info .info .title { font-size:22px; }
    .playlist-info .info .artist { margin-top:4px; }
    .playlist-info .info .buttons { margin-top:8px; }
  }
}

/* A short landscape viewport can come from DevTools or a compact desktop
   window without a coarse pointer. Keep the detail header phone-sized even
   when the mobile navigation shell is intentionally not switched on. */
@media (min-width:600px) and (max-width:1023px) and (max-height:599px) {
  #app.salt-shell .playlist.salt-detail {
    .playlist-info { flex-direction:row; align-items:flex-start; gap:16px; margin-bottom:16px; }
    .playlist-info > .cover { align-self:flex-start; flex:0 0 96px; width:96px; height:96px; }
    .playlist-info .info { flex:1; width:auto; }
    .playlist-info .info .title { font-size:22px; }
    .playlist-info .info .artist { margin-top:4px; }
    .playlist-info .info .buttons { margin-top:8px; }
    .salt-ui-button { min-width:44px; min-height:44px; max-width:100%; }
  }
}
</style>

<style lang="scss" scoped>
/* Phones retain one action rail. Secondary commands collapse to named icons,
   while the primary Play command and desktop labels remain readable. */
.detail-action-icon { display:none; }
@media (max-width:599px), (max-width:1023px) and (max-height:599px) and (pointer:coarse) {
  .playlist {
    .playlist-info .buttons.detail-actions { display:flex; flex-wrap:nowrap; gap:6px; min-width:0; width:100%; }
    .buttons.detail-actions > button { flex:none; min-width:44px; min-height:44px; height:44px; margin:0; padding-inline:12px !important; font-size:14px; white-space:nowrap; }
    .buttons.detail-actions > button.detail-secondary { flex:0 0 44px; width:44px; padding:0 !important; }
    .detail-secondary .detail-action-label { display:none; }
    .detail-action-icon { display:block; flex:none; width:20px; height:20px; margin:0 !important; }
    .buttons.detail-actions ::v-deep .label { white-space:nowrap; }
    
  }
}
@media(max-width:599px) {
  .playlist:not(.salt-detail) {
    .playlist-info { width:100%; flex-direction:column; align-items:stretch; gap:16px; margin-bottom:20px; }
    .playlist-info .info { flex:none; width:100%; min-width:0; margin:0; }
    .playlist-info > .cover { align-self:center; width:144px !important; height:144px !important; }
    .playlist-info > .cover ::v-deep img { width:144px !important; height:144px !important; object-fit:cover; }
  }
}
</style>
